import React from "react";
import { CONSTANTS } from "../../constants/Constants";

interface ModifyProfileMenuProps {
  setActiveTab: (Tab: string) => void;
  activeTab: string;
}

const ModifyProfileMenu: React.FC<ModifyProfileMenuProps> = ({
  setActiveTab,
  activeTab,
}) => {

  const menuItems = [
    CONSTANTS.BASIC_INFO_TXT,
    CONSTANTS.MEDIA_TXT,
    CONSTANTS.QNA_TXT,
    CONSTANTS.EXPERIENCE_HEADING_TXT,
    CONSTANTS.EDUCATION_HEADING_TXT,
  ];

  return (
    <div className="bg-white w-full lg:w-60 lg:h-screen lg:border-r py-4 pr-4">
      <ul className="lg:space-y-2 flex flex-wrap justify-center lg:block">
        {menuItems.map((item) => (
          <li
            key={item}
            className={`p-3 relative text-sm font-medium rounded-lg cursor-pointer ${activeTab === item
              ? "text-primary border-b-4 border-primary overflow-hidden"
              : "hover:bg-gray-100"
              }`}
            onClick={() => setActiveTab(item)}
          >
            <div className="z-10">
              {item}
            </div>
            <div className={`${activeTab === item ? "bg-primary" : ""} opacity-10 h-full z-0 top-0 left-0 w-full absolute`}></div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ModifyProfileMenu;
